// extracted by mini-css-extract-plugin
module.exports = {"footer":"wsYiS","main":"n94qe","sidebar":"qPfwA","content":"I33U9","row":"SjVwd","show_tabletMedium":"ise4W","gutter_increase":"keM8v"};